import { createFileRoute } from "@tanstack/react-router"

import DemandTab from "~/components/demand-2/tabs/DemandTab"
import { FilterScopeProvider } from "~/providers/FilterScopeProvider"

export const Route = createFileRoute("/_auth/demand/fashion/$collectionId/_layout/demand")({
  component: RouteComponent,
})

function RouteComponent() {
  const { collectionId } = Route.useParams()
  // A fixed key: other tabs' links write here, and writes on leaving must not follow the route.
  return (
    <FilterScopeProvider scopeKey={Route.id}>
      <DemandTab collectionId={Number(collectionId)} kind="fashion" />
    </FilterScopeProvider>
  )
}
